import { useQuery } from "@tanstack/react-query";
import dateFormat from "dateformat";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { Rating } from "./rating";

const OurAllProjects = () => {
  const [searchInfo, setSearchInfo] = useState({
    // name: null,
    country: null,
    industry: null,
    status: null,
  });
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/all-project`)
      .then((res) => res.json())
      .then((result) => {
        setProjects(result.projects);
      });
  }, []);

  const { data: searchItem } = useQuery(["searchItem"], async () => {
    const response = await window.fetch(`${BASE_URL}/search-iteam`);
    return await response.json();
  });

  const defaultIndustry = [
    { value: "", label: "Search for project by Industry" },
  ];
  const defaultIndustryOptions = searchItem?.industry?.map((data) => ({
    label: data?.title,
    value: data?.id,
    industry: 1,
  }));
  // const defaultName = [
  //   { value: "", label: "Search for project by Client Name" },
  // ];
  // const defaultNameOptions = searchItem?.name?.map((data) => ({
  //   label: data?.client_name,
  //   value: data?.client_name,
  //   name: 4,
  // }));
  const defaultCountry = [{ value: "", label: "Sort by Country" }];
  const defaultCountryOptions = searchItem?.country?.map((data) => ({
    label: data?.name,
    value: data?.id,
    country: 2,
  }));
  const defaultClient = [{ value: "", label: "Sort by Status" }];
  const defaultClientOptions = [
    {
      label: "Delivered",
      value: 1,
      status: 3,
    },
    {
      label: "In-Progress",
      value: 2,
      status: 3,
    },
    {
      label: "Awarded",
      value: 3,
      status: 3,
    },
  ];

  async function handleSelect(event) {
    setSearchInfo({
      country: event.country === 2 ? event.value : searchInfo.country,
      // name: event.name === 4 ? event.value : searchInfo.name,
      industry: event.industry === 1 ? event.value : searchInfo.industry,
      status: event.status === 3 ? event.value : searchInfo.status,
    });
  }

  const handleClick = () => {
    fetch(`${BASE_URL}/search-project`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(searchInfo),
    })
      .then((res) => res.json())
      .then((result) => {
        setProjects(result?.datas);
      });
  };

  return (
    <>
      <div className="">
        <h1 className="fs-56 lh-64 gilroy-bold text-center">
          Explore our portfolio of projects
        </h1>
        <p className="fs-20 lh-30 text-align-justify">
          We are a leading vendor in the network and IP infrastructure,
          software, and the related services market. We provide a broad range of
          products, from the Telecom contractors of networks used by
          communication service providers and increasingly by customers in other
          select verticals, to software solutions, as well as services to plan,
          optimize, implement, run and upgrade networks.
        </p>
        <div className="mt-5">
          <div className="py-5">
            <h2 className="fs-28 lh-40 gilroy-bold text-center">
              FILTER BY PROJECTS DIMENSIONS
            </h2>
            <div className="row justify-content-center pt-5">
              <div className="col-12 col-md-4 mb-4 mb-md-0">
                <Select
                  defaultValue={defaultIndustry}
                  // formatOptionLabel={formatOptionLabel}
                  options={defaultIndustryOptions}
                  onChange={handleSelect}
                  // key={selectedCountry?.id || 1}
                />
              </div>
              {/* <div className="col-12 col-md-4">
                <Select
                  defaultValue={defaultName}
                  // formatOptionLabel={formatOptionLabel}
                  options={defaultNameOptions}
                  onChange={handleSelect}
                  // key={selectedCountry?.id || 1}
                />
              </div> */}
              <div className="col-12 col-md-4 mb-4 mb-md-0">
                <Select
                  defaultValue={defaultCountry}
                  // formatOptionLabel={formatOptionLabel}
                  options={defaultCountryOptions}
                  onChange={handleSelect}
                  // key={selectedCountry?.id || 1}
                />
              </div>

              <div className="col-12 col-md-4 mb-4 mb-md-0">
                <Select
                  defaultValue={defaultClient}
                  // formatOptionLabel={formatOptionLabel}
                  options={defaultClientOptions}
                  onChange={handleSelect}
                  // key={selectedCountry?.id || 1}
                />
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-md-2 mx-auto">
                <p
                  className="bg-american-yellow text-white w-100 fs-16 d-inline-block text-center py-4 cursor-pointer"
                  onClick={handleClick}
                >
                  Search
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5">
        {projects.length === 0 && (
          <p className="fs-22 text-center">No Projects Founds</p>
        )}
        <div className="row">
          {projects?.map((project, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 mb-5 mb-md-0">
              <Link
                to={`/clients/project-details/${project?.id}`}
                className="text-decoration-none"
              >
                <div className="bg-white p-3 rounded-lg mb-5 review-shadow position-relative transform-up h-100">
                  <div className="d-flex justify-content-center">
                    <img
                      src={`${IMAGE_BASE_URL}/${project?.image}`}
                      alt="user"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="text-center mt-3">
                    <h3 className="fs-18 fw-bold text-secondary cut-line-1">
                      {project?.title}
                    </h3>

                    <div className="d-flex justify-content-center">
                      <Rating />
                    </div>

                    <div className="my-3">
                      <p className="fs-16 text-secondary text-start cut-line">
                        {project?.short_description}
                      </p>
                    </div>

                    <div className="text-start fs-14 text-secondary">
                      {project?.starting_date && (
                        <p>
                          <span className="gilroy-bold">Stating Date : </span>
                          {dateFormat(project?.starting_date, "dS mmmm, yyyy")}
                        </p>
                      )}
                      {project?.end_date && (
                        <p>
                          <span className="gilroy-bold">Ending Date : </span>
                          {dateFormat(project?.end_date, "dS mmmm, yyyy")}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="review-card-border"></div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurAllProjects;
